@if (onlineStatus === 'online') {
    <div class="online">
            <span>{{onlineStatusMessage}}</span>
    </div>
}
@if (onlineStatus === 'offline') {
    <div class="offline">
            <span>{{onlineStatusMessage}}</span>
    </div>
}